var timeAndDayInterval = require('./time_and_day_interval');

exports.fieldsNeeded = ['currentTimestamp'];

exports.match = function(value, cond) {
  return timeAndDayInterval.test(cond.value, new Date(value.currentTimestamp));
};
